var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.094 27.166a.516.516 0 0 1-.516-.516V5.795a2.847 2.847 0 0 1 2.843-2.846h7.482a2.848 2.848 0 0 1 2.815 2.45H26.47a3.154 3.154 0 0 1 3.148 3.154v3.593a.516.516 0 1 1-1.033 0V8.553a2.12 2.12 0 0 0-2.116-2.12H13.23a.516.516 0 0 1-.516-.517v-.122c0-.999-.812-1.811-1.81-1.811H3.421c-.999 0-1.81.812-1.81 1.812V26.65c0 .285-.232.516-.517.516Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.143 29.078H2.691c-.667 0-1.252-.264-1.647-.743-.394-.477-.547-1.126-.421-1.783l2.43-12.593c.249-1.285 1.507-2.33 2.804-2.33H30.31c.668 0 1.254.264 1.65.744.393.477.546 1.127.419 1.782l-2.43 12.592c-.25 1.286-1.508 2.33-2.805 2.33ZM5.857 12.662c-.813 0-1.634.685-1.791 1.494l-2.43 12.592c-.068.358.004.688.203.929.196.237.498.367.852.367h24.452c.814 0 1.634-.683 1.791-1.492l2.43-12.593c.069-.357-.003-.686-.202-.928-.196-.238-.5-.369-.853-.369H5.857Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.576 14.499a.516.516 0 0 1-.517-.517V9.157c0-.473.385-.858.858-.858h21.82c.472 0 .856.385.856.858v2.988a.516.516 0 1 1-1.032 0V9.332H4.09v4.65c0 .285-.23.517-.515.517Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.3efbb3edfd11010b24466811a8ca97c7.svg";
export { ForwardRef as ReactComponent };